var _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgInfo = _ref => {
  let svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#433D3E",
    fillRule: "nonzero",
    d: "M9.387 12.685v-.506c0-.438.093-.818.28-1.142.187-.323.529-.668 1.025-1.032.479-.342.794-.62.947-.834.153-.214.23-.454.23-.718 0-.296-.11-.522-.329-.677-.219-.155-.524-.232-.916-.232-.684 0-1.463.223-2.338.67l-.745-1.497a6.513 6.513 0 0 1 3.233-.855c.94 0 1.685.226 2.24.677.553.451.83 1.053.83 1.805 0 .501-.114.934-.342 1.299-.228.364-.66.774-1.299 1.23-.437.324-.714.57-.83.738-.117.169-.175.39-.175.663v.41H9.387zm-.219 2.337c0-.382.103-.672.308-.868.205-.196.503-.294.895-.294.378 0 .671.1.879.301.207.2.31.488.31.861 0 .36-.104.644-.314.852-.21.207-.501.31-.875.31-.383 0-.679-.1-.889-.304-.21-.202-.314-.488-.314-.858z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInfo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/info.ed2ac9b8.svg";
export { ForwardRef as ReactComponent };